import React, { useEffect, useState } from 'react'
import { CustomDataTableHeader, CustomPanel, PageHeader } from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import useOperacaoMovimentacaoInsumo, { LOADING_MESSAGES } from './OperacaoMovimentacaoInsumoHook'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import OperacaoMovimentacaoInsumoModal from './OperacaoMovimentacaoInsumoModal'

function OperacaoMovimentacaoInsumo({ history, dispatch }) {
  // Hook
  const { state, localDispatch } = useOperacaoMovimentacaoInsumo()
  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    localDispatch.setLoading(LOADING_MESSAGES.INITIAL_FETCH)
  }, [])

  useEffect(() => {
    if (state.loadingMessage === LOADING_MESSAGES.INITIAL_FETCH) {
      dispatch(showLoadingBox(state.loadingMessage, 'Aguarde'))
      localDispatch.getOperacoesMovimentacaoInsumos()
    } else if (state.loadingMessage === LOADING_MESSAGES.NONE) {
      dispatch(hideLoadingBox())
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  // Render
  return (
    <>
      <PageHeader>S.14 - Operações de Movimentação de Insumo</PageHeader>
      <CustomPanel onNovo={localDispatch.onBtnNovoClick} onVoltar={history.goBack}>
        <div className="p-grid">
          <div className="p-col-12">
            <DataTable
              value={state.operacoes}
              emptyMessage={'Não existe nenhuma Operação de Movimentação de Insumo Cadastrada'}
              globalFilter={globalFilter}
              header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
              selectionMode={'single'}
              onSelectionChange={e => localDispatch.onItemClick(e.value)}
            >
              <Column field={'id'} header={'Código'} style={tableCellCentered(80)} />
              <Column field={'type'} header={'Tipo'} style={tableCellCentered(130)} />
              <Column field={'name'} header={'Operação de Movimentação - Insumo'} />
            </DataTable>
          </div>
        </div>
      </CustomPanel>
      <OperacaoMovimentacaoInsumoModal
        onResponse={localDispatch.onModalResponse}
        visible={state.showModal}
        selectedOperacao={state.selectedOperacao}
      />
    </>
  )
}

export default connect()(withRouter(OperacaoMovimentacaoInsumo))
